export default {
    en: {
        buttons: {
            load: 'Load Excel'
        },
        period: 'Period',
        status: 'Status',
        importer: 'User',
        imported_rows: 'Imported Rows',
        inserted_rows: 'Inserted Rows',
        faulty_rows: 'Faulty Rows',
        creator: 'Creator',
        created_at: 'Created',
        action: 'Actions',
        rows: 'Rows',
        statuses: {
            uploaded: 'Saved',
            validated: 'Validated',
            half_import: 'Partial Import',
            imported: 'Imported',
            partial_import:'Partial Import',
            processing: 'Processing'
        },
    },
    et: {
        buttons: {
            load: 'Laadi Excel',
            download: 'Laadi vigaste ridade raport',
            reupload: 'Laadi fail uuesti üles',
            import: 'Impordi ALIS-isse'
        },
        period: 'Periood',
        status: 'Staatus',
        importer: 'Kasutaja',
        imported_rows: 'Sisestatud ridu',
        inserted_rows: 'Sisestatud',
        faulty_rows: 'Veaga read',
        creator: 'Looja',
        created_at: 'Loodud',
        action: 'Toimingud',
        rows:'Read',
        statuses: {
            uploaded: 'Salvestatud',
            validated: 'Valideeritud',
            half_import: 'Pooleldi sisestatud',
            imported: 'Sisestatud',
            partial_import:'Pooleldi sisestatud',
            processing: 'Töötlemisel'
        },
        upload_file: 'Palun laadi üles fail. Faili nimeks peab olema kõnealune periood',
        file_uploaded: 'Fail laaditi edukalt üles',
        data: 'Rea sisu',
        errors: 'Valideerimise vead',
        imported: 'Sisestatud',
        date:'Kuupäev',
        payment_number:'Arve number',
        payment_date:'Maksekuupäev',
        vin:'VIN',
        related_amount:'Summa',
        explanation:'Selgitus',
        info: 'Info',
        reg_number:'Auto number',
        operations:'Toiming',
        office:'Kontor',
        re_upload_title: 'Faili üles laadimine',
        re_upload_confirm:'Laadi uuesti üles'


    }
}